import React from "react";
import NoticeCard from "./NoticeCard";

const Notices = () => {
  const cardData = [
    {
      name: "Public Notices",
      text: "Stay informed with the  updates and announcements from Rawalpindi Development Authority",
      icon: "/icon/publicNotice.svg",
      link: "/public-notices",
      class: "animate-slideLeft",
    },
    {
      name: "Latest News",
      text: "Stay updated with the latest developments and initiatives from Rawalpindi Development Authority",
      icon: "/icon/pressRelease.svg",
      link: "/latest-news",
      class: "animate-slideLeft",
    },
    {
      name: "Careers",
      text: "Looking to start your career with us? Follow to know about current job openings",
      icon: "/icon/career.svg",
      link: "/careers",
      class: "animate-slideRight",
    },
    {
      name: "Tenders",
      text: "Follow for tenders issued and advertised by Rawalpindi Development Authority",
      icon: "/icon/tender.svg",
      link: "/tenders",
      class: "animate-slideRight",
    },
    {
      name: "Building Plans",
      text: "View approved building plans and guidelines for safe and compliant contruction.",
      icon: "/icon/building-plans.svg",
      link: "/building-plans",
      class: "animate-slideLeft",
    },
  ];

  return (
    <div className=" bg-[#00643b] my-8 flex flex-col gap-4 md:py-12 py-8 md:px-8 px-4 justify-center items-center w-full">
      <span className="lg:text-[2.5rem] md:text-[2rem] text-[1.8rem] text-center text-white font-bold">
        Important Notices
      </span>
      <span className=" md:text-[1.2rem] text-[1rem] lg:w-[70%] sm:w-[85%] w-[95%] mx-auto text-[#BDBDBD] text-center">
        Stay informed with vital updates and essential announcements from
        Rawalpindi Development Authority. Check here regularly for important
        notices and timely information
      </span>
      <div className=" w-full mt-8 flex justify-center items-stretch flex-wrap max-w-6xl   gap-4  ">
        {cardData.map((cd, i) => (
          <NoticeCard key={i} cd={cd} />
        ))}
      </div>
    </div>
  );
};

export default Notices;
